// AI-ASSISTED: generated with claude-code on 2026-08-18, reviewed by Yoann Hertienne
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { EntityCardBlueprint } from '@backstage/plugin-catalog-react/alpha';

export { NpmAuditCard } from './NpmAuditCard';

const npmAuditCard = EntityCardBlueprint.make({
  name: 'npm-audit',
  params: {
    filter: 'kind:component',
    loader: async () => {
      const { NpmAuditCard } = await import('./NpmAuditCard');
      return <NpmAuditCard />;
    },
  },
});

export const npmAuditCardModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [npmAuditCard],
});
